module.exports = __webpack_public_path__ + "media/images/sankro-keycgain-e514bb35728ffc5e75652bba4a5b7932.jpeg";